// MARK://dhk8/admin-shell/lib/clients/devices
// Impresoras + estaciones KDS.
//
// CONTRACT GAP: `dhk8-pos-printing` exposes print *templates* and print *jobs*
// (`/v1/print/templates`, `/v1/print/jobs`) but NO printer-device CRUD, and there is
// no `dhk8-kds-tickets` service in this monorepo. Physical printer registration lives
// (partially) in `dhk8-platform-devices` (`/v1/devices/*`, device-registry style), not
// as the IP-addressed "printer" rows the admin's DevicesPage edits. Until a real
// printers/KDS CRUD exists, this client returns empty lists against the real backend
// (the page shows "Sin impresoras" / "Sin estaciones" instead of erroring) and the
// mutations throw a clear message. The full PREVIEW seed is kept.
// TODO(backend): a printers CRUD (likely on dhk8-pos-printing or dhk8-platform-devices)
// + a KDS-stations resource; then repoint here.
import { PREVIEW_STUB, mock } from '../env.js'
import * as M from '../mock-data.js'

const db = { printers: structuredClone(M.PRINTERS), stations: structuredClone(M.KDS_STATIONS) }
const id = (p: string) => `${p}-${Math.random().toString(36).slice(2, 8)}`
const NO_BACKEND = 'Configuración de impresoras/KDS aún no disponible en el backend'

export async function listPrinters(_signal?: AbortSignal): Promise<M.Printer[]> {
  if (PREVIEW_STUB) return mock(db.printers)
  return [] // TODO(backend): no printers CRUD yet — see header.
}
export async function createPrinter(input: Omit<M.Printer, 'id' | 'online'>): Promise<M.Printer> {
  if (PREVIEW_STUB) { const p = { ...input, id: id('pr'), online: false }; db.printers.push(p); return mock(p) }
  throw new Error(NO_BACKEND)
}
export async function updatePrinter(p: M.Printer): Promise<M.Printer> {
  if (PREVIEW_STUB) { const i = db.printers.findIndex((x) => x.id === p.id); if (i >= 0) db.printers[i] = p; return mock(p) }
  throw new Error(NO_BACKEND)
}
export async function deletePrinter(prId: string): Promise<void> {
  if (PREVIEW_STUB) { db.printers = db.printers.filter((x) => x.id !== prId); return mock(undefined) }
  throw new Error(NO_BACKEND)
}
export async function testPrint(_prId: string): Promise<void> {
  if (PREVIEW_STUB) return mock(undefined, 400)
  throw new Error(NO_BACKEND)
}

export async function listKdsStations(_signal?: AbortSignal): Promise<M.KdsStation[]> {
  if (PREVIEW_STUB) return mock(db.stations)
  return [] // TODO(backend): no KDS stations resource yet — see header.
}
export async function createKdsStation(input: Omit<M.KdsStation, 'id'>): Promise<M.KdsStation> {
  if (PREVIEW_STUB) { const s = { ...input, id: id('kds') }; db.stations.push(s); return mock(s) }
  throw new Error(NO_BACKEND)
}
export async function updateKdsStation(s: M.KdsStation): Promise<M.KdsStation> {
  if (PREVIEW_STUB) { const i = db.stations.findIndex((x) => x.id === s.id); if (i >= 0) db.stations[i] = s; return mock(s) }
  throw new Error(NO_BACKEND)
}
export async function deleteKdsStation(sId: string): Promise<void> {
  if (PREVIEW_STUB) { db.stations = db.stations.filter((x) => x.id !== sId); return mock(undefined) }
  throw new Error(NO_BACKEND)
}
